module.exports = __webpack_public_path__ + "static/img/map.c4efee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/map.png
// module id = oGSf
// module chunks = 0